enum UnitId {
  M = 10,
  M2 = 4,
  M3 = 1,
  KG = 0,
  PIECE = 11,
  PERCENTAGE = 13,
}

export default UnitId;
